import { getDataWithPromise, Globals, handleAjaxError } from "./BaseDataFns";

export const getUserDetails = (user_id, child_uid, onCompleteFunc) => {
    let url = '';

    if(child_uid !== null){
        url = Globals.APIFolder + '/users/' + user_id + '?child_uid=' + child_uid;
    }
    else{
        url = Globals.APIFolder + '/users/' + user_id;
    }

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

export const getBlockedUsersInOrg = ( org_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/organisation/' + org_id + '/users?user_type=blocked' ;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

export const getMyUsersInOrg = ( org_id, user_type, user_status, onCompleteFunc) => {

    const url = Globals.APIFolder + '/organisation/' + org_id + '/teams/user/users?user_type=' + user_type  + '&application=arcom&user_status=' + user_status;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

export const saveNewUser = ( postFormData, onCompleteFunc) => {

    const url = Globals.APIFolder  + '/usersV2';

    getDataWithPromise(url, 'POST', {formData: postFormData}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
};

export const updateUserDetails = ( user_id, postFormData, onCompleteFunc) => {

    const url = Globals.APIFolder  + '/users/' + user_id;

    getDataWithPromise(url, 'POST', {formData: postFormData}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
};

export const getUserImageUrl = (document_id, user_id) => {

    var url = '';

    if(document_id === null || document_id === undefined){
        url = '/images/defaultPerson.jpg'
    }
    else{
        url = Globals.APIFolder + '/child/' + user_id + '/document/' + document_id + '?size=100&square=false';
    }

    return url;
};

export const getUserOrganisationDetails = ( org_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/organisation/' + org_id;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

export const suspendUser = ( user_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/users/' + user_id + '/suspend';

    getDataWithPromise(url, 'put', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

export const reinstateUser = ( user_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/users/' + user_id + '/reinstate';

    getDataWithPromise(url, 'put', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

export const archiveUser = ( user_id, onCompleteFunc ) => {

    const url = Globals.APIFolder + '/users/' + user_id ;

    getDataWithPromise(url, 'delete', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

export const unblockUser = ( user_id, blocked_by ) => {

    const url = Globals.APIFolder + '/users/' + user_id + '/blocked/' + blocked_by ;

    getDataWithPromise(url, 'put', {}).then(data =>
    {
        window.location.reload();
        //onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

export const inviteAgain = ( user_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/users/' + user_id + '/inviteAgain';

    getDataWithPromise(url, 'put', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

export const saveNewPassword = ( user_id, postFormData, onCompleteFunc) => {

    const url = Globals.APIFolder  + '/users/' + user_id + '/changePassword';

    getDataWithPromise(url, 'POST', {formData: postFormData}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
};

////////////////////////////////////////
// User roles
////////////////////////////////////////
// Removes all roles for the specified connection
export const removeConnectionInBothDirections = (connection1, connection2,  onCompleteFunc) => {

    const url = Globals.APIFolder + '/users/connection?con1=' + connection1 + '&con2=' + connection2;

    getDataWithPromise(url, 'delete', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

//gets user roles for connection
export const getUserRoles = (to_user_id, from_user_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/users/' + to_user_id + '/roles/' + from_user_id;

    getDataWithPromise(url, 'get', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

//gets user roles for connection
export const getUserRelationAndPermission = (to_user_id, from_user_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/users/' + to_user_id + '/relation/' + from_user_id;

    getDataWithPromise(url, 'get', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

//Creates a user connection
export const createUserRoles = (from_user_id, to_user_id, formData, onCompleteFunc) => {

    const url = Globals.APIFolder + '/users/' + to_user_id + '/roles/' + from_user_id;

    getDataWithPromise(url, 'POST', { formData: formData }).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
};

// Changes a specified role for the specified user connection
export const updateUserRoles = (from_user_id, to_user_id, formData, onCompleteFunc) => {

    const url = Globals.APIFolder + '/users/' + to_user_id + '/roles/' + from_user_id;

    getDataWithPromise(url, 'put', {formData: formData}).then(data =>
    {
        onCompleteFunc ( data );
    })
    .catch((jqXHR, textStatus, error) =>
    {
        handleAjaxError(jqXHR, textStatus, error);
    });

    return ;
};

/*export const getUserConnections = (user_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/users/' + user_id + '/connections' ;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};*/

export const getUserConnections2 = (user_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/users/' + user_id + '/connections2' ;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

export const getMyContributors = ( user_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/users/' + user_id + '/contributors';

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};